module.exports = __webpack_public_path__ + "static/img/15.b23171d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/15.png
// module id = awOW
// module chunks = 0